import React, { useRef, useEffect } from "react";
import parse from "html-react-parser";
// import { Parallax } from "react-parallax";
// import { Parallax } from 'react-parallax';

export default function HeroStyle3({
  title,
  miniTitle,
  // subTitle,
  // thumbnailSrc,
}) {
  const videoRef = useRef();

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 1; // Adjust the playback rate as needed
      videoRef.current.play();
    }
  }, []);

  return (
    <section
      className="cs_hero cs_style_2 cs_bg_filed cs_center position-relative flexcontainer "
      style={{ paddingLeft: '20px', paddingRight: '20px' }}
    >
      {/* <section className="cs_hero cs_style_2 position-relative"> */}
      {/* left div */}
      <div className="container position-relative margincontainer" style={{ maxWidth: "75%", zIndex: '1' }}>
        <div className="cs_hero_text col-lg-2 margincustom">
          <h3
            className="cs_hero_title_mini text-uppercase"
            style={{ color: "#C8AA86", fontSize: "40px", marginBottom: 0 }}
          >
            {parse(miniTitle)}
          </h3>
          <h1
            className="cs_hero_title cs_fs_68 text-uppercase"
          >
            {parse(title)}
          </h1>
        </div>
        {/* icon arrow down */}
        <div className="col-lg-2 margincustom " style={{zIndex: "111", position: "relative"}}>
          <a href="#content" className="cs_down_btn cs_center cs_primary_color">
            <svg
              width={8}
              height={33}
              viewBox="0 0 8 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.64645 32.3536C3.84171 32.5488 4.15829 32.5488 4.35355 32.3536L7.53554 29.1716C7.7308 28.9763 7.7308 28.6597 7.53554 28.4645C7.34027 28.2692 7.02369 28.2692 6.82843 28.4645L4 31.2929L1.17157 28.4645C0.976312 28.2692 0.65973 28.2692 0.464467 28.4645C0.269205 28.6597 0.269205 28.9763 0.464467 29.1716L3.64645 32.3536ZM3.5 2.18557e-08L3.5 32L4.5 32L4.5 -2.18557e-08L3.5 2.18557e-08Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>

      {/* right div */}
      <div className="mobile-right-div" style={{  }}>
        <video  ref={videoRef} width="100%" height="auto" autoPlay muted playbackRate={2.0}>
          <source src="/images/others/videoplay.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
    // </section>
  );
}
